import { IMessage } from "@interfaces/chat/chatI";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export const messageSocketQueueSlice = createSlice({
    name: "messageSocketQueue",
    initialState: {
        messages: [],
    } as {messages: IMessage[]},
    reducers:{
        setMessageSocketQueue: (state, action: PayloadAction<IMessage>) => {
            const index = state.messages.findIndex(c => action.payload.id === c.id);
            if(index === -1)
                state.messages.push(action.payload);
            else
            {
                state.messages[index] = action.payload;
            }
        },
        removeMessagetSocketQueue: (state, action: PayloadAction<IMessage>) => {
            const filteredData = state.messages.filter(contact => contact.id !== action.payload.id);
            // console.log("removeMessageSocketQueue", filteredData);
            state.messages = filteredData;
        },
        cleanMessageSocketQueue: (state) => {
            state.messages = [];
        }
    }
});

export const {setMessageSocketQueue, removeMessagetSocketQueue, cleanMessageSocketQueue} = messageSocketQueueSlice.actions;
export default messageSocketQueueSlice.reducer;